<section class="related-categories" appIsVisible (isVisible)="initializeRelatedCategoriesView()">
  <h3 *ngIf="title" class="related-categories__title">{{ title }}</h3>
  <app-related-categories-grid [categories]="categories$ | async" [isMobile]="isMobile"></app-related-categories-grid>
</section>
